import { MOKA_INVENTORY_API } from '../constants';

export const V1_URL = `${MOKA_INVENTORY_API}/v1/ingredients`;

export const V1_ALL = `${V1_URL}/all`;

export const V1_HAVE_RECIPE = `${V1_URL}/have_recipe`;
